// extracted by mini-css-extract-plugin
export var container = "lifetime-benefits-section-module--container--BlemO";
export var titleWrapper = "lifetime-benefits-section-module--title-wrapper--BqeN-";
export var description = "lifetime-benefits-section-module--description--DX35z";
export var inner = "lifetime-benefits-section-module--inner--i9Vmw";